<template>
  <v-card dark>
    <v-card-title v-if="props.title">
      {{ props.title }}
    </v-card-title>
    <v-card-subtitle>
      {{item}}
    </v-card-subtitle>
    <v-card-text>
      <v-select
        color="amber"
        label="Select an item"
        :items="props.items"
        @change="change"
        item-text="title"
        item-value="id"
      />
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "InputDropdown",
  props: {
    props: {
      type: Object,
      default: null,
    },
    value: String,
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
  methods: {
    change(ev) {
      console.log(ev);
      this.item = ev;
    },
  },
};
</script>

<style lang="scss"></style>
